import { useQuery } from '@tanstack/react-query';
import { getPortalPlans } from './api';

const FIVE_MINUTES = 5 * 60 * 1000;

/** The plan catalogue, fetched only when asked (`enabled`) so a test run does not pay for it up front. */
export function usePortalPlans(enabled: boolean) {
  return useQuery({
    queryKey: ['portal-plans'],
    queryFn: ({ signal }) => getPortalPlans(signal),
    enabled,
    staleTime: FIVE_MINUTES,
    retry: false,
  });
}
